import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-star-rating',
	templateUrl: './star-rating.component.html',
	styleUrls: ['./star-rating.component.scss']
})
export class StarRatingComponent implements OnInit {

	@Input() rating! : number;
	@Input() caption? : string | number;
	@Input() color : "primary"|"accent"|"black" = "black";
	@Input() classes : string = "";
	@Input() size : "small"|"large" = "small";
	@Output() eeClick = new EventEmitter<void>();

	mask_1_width = 0;
	mask_2_width = 0;
	mask_3_width = 0;
	mask_4_width = 0;
	mask_5_width = 0;

	ngOnInit(): void {
		if (this.rating <= 1) {
			this.mask_1_width = this.rating * 100;
		} else if (this.rating <= 2) {
			this.mask_1_width = 100;
			this.mask_2_width = (this.rating-1) * 100;
		} else if (this.rating <= 3) {
			this.mask_1_width = 100;
			this.mask_2_width = 100;
			this.mask_3_width = (this.rating-2) * 100;
		} else if (this.rating <= 4) {
			this.mask_1_width = 100;
			this.mask_2_width = 100;
			this.mask_3_width = 100;
			this.mask_4_width = (this.rating-3) * 100;
		} else if (this.rating <= 5) {
			this.mask_1_width = 100;
			this.mask_2_width = 100;
			this.mask_3_width = 100;
			this.mask_4_width = 100;
			this.mask_5_width = (this.rating-4) * 100;
		}
	}
}
